// 'use strict';
import '../App.css';
import { useState } from 'react';

const curFontSize = '13px';
const myStyle =
{
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    fontSize: curFontSize,
    lineHeight: '2',
};
const checlboxstyle =
{
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    fontSize: curFontSize,
    lineHeight: '2',
    justifyContent: "center"
};
const myHeaderStyle = {
    textAlign: 'center',
    fontWeight: 'bold',
    textWrap: 'wrap',
    height: '100%',
    justifyContent: 'center'
}

export function GetDefaultColDefs(onCheckboxChange) {
    return [
        {
            headerName: '#',
            field: "rownum",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: simpleRenderer,
            width: 50,
            pinned: 'left',
            headerClass: 'App-header'
        },
        {
            headerName: 'Source Line Item',
            field: "fullsource",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: fullSourceRenderer,
            width: 500,
            pinned: 'left',
            headerClass: 'App-header'
        },

        {
            headerName: 'Valid',
            field: "isvalid",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap'},
            cellRenderer: IsValidRenderer,
            width: 100,
            headerClass: 'App-header'
        },
        
        {
            headerName: 'LLM Company, Brand, Sub Brand',
            field: "cbp",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: cbpRenderer,
            width: 400,
            headerClass: 'App-header'
        },

        {
            headerName: 'LLM Assigned GS1 Category',
            field: "matchedgs1path",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: GS1Renderer,
            width: 400,
            headerClass: 'App-header'
        },

        {
            headerName: 'OM1 Brand Subbrand',
            field: "omone",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: OM1Renderer,
            width: 400,
            headerClass: 'App-header'
        },

        {
            headerName: 'Odd man Pass?',
            field: "passoddmanfilter",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap'},
            cellRenderer: IsValidRenderer,
            width: 120,
            headerClass: 'App-header'
        },

         
        {
            headerName: "Validation Reasoning",
            field: "validationreasoning",
            headerStyle: myHeaderStyle,
            cellStyle: { whiteSpace: 'pre-wrap' },
            cellRenderer: simpleRenderer,
            width: 400,
            headerClass: 'App-header'
        },

        {
            headerName: 'Incorrect',
            field: 'iscorrect',
            headerStyle: myHeaderStyle,
            fontSize: '10px',
            editable: true,
            cellRenderer: CheckBoxRenderer,
            cellRendererParams: {
                onCheckboxChange: onCheckboxChange
            },
            width: 120,
            headerClass: 'App-header'
        }
    ]
};


export function simpleRenderer({ value }) {
    return <span style={myStyle}>
        {value}
    </span>;
};

const CheckBoxRenderer = (props) => {
    const [checked, setChecked] = useState(props.value);

    let retVal = <input type="checkbox" class="iscorrect-class" name="isCorrect" onChange={increment} value="curValue" checked={checked}></input>;

    function increment(event) {
        setChecked(event.target.checked);
        props.onCheckboxChange(props.data, event.target.checked);
    };

    return <span style={checlboxstyle}>
        {retVal}
    </span>;
}

export function fullSourceRenderer({ value }) {
    value = value.replace(/\n/g, ":");

    let cellValue = value;
    let textToBold = ":";
    let parts = cellValue.split(textToBold);

    let str = "";

    if (parts && parts.length >= 11) {
        let internals = <div>
            <p><span class="bolded-text">{parts[0] + ":"}</span>{parts[1]}</p>
            <p><span class="bolded-text">{parts[2] + ":"}</span>{parts[3]}</p>
            <p><span class="bolded-text">{parts[4] + ":"}</span>{parts[5]}</p>
            <p><span class="bolded-text">{parts[6] + ":"}</span>{parts[7]}</p>
            <p><span class="bolded-text">{parts[8] + ":"}</span>{parts[9]}</p>
            <p><span class="bolded-text">{parts[10] + ":"}</span>{parts[11]}</p>
            <p><span class="bolded-text">{parts[12] + ":"}</span>{parts[13]}</p>
            <p><span class="bolded-text">{parts[14] + ":"}</span>{parts[15]}</p>
        </div>

        str =
            <span style={myStyle}>
                {internals}
            </span>
    }
    else {
        str = <span style={myStyle}>
            {value}
        </span>;
    }

    return str;
};


export function cbpRenderer({ value }) {
    if (!value)
        return;

    value = value.replace(/\n/g, ":");

    let cellValue = value;
    let textToBold = ":";
    let parts = cellValue.split(textToBold);

    let str = "";

    if (parts && parts.length >= 6) {
        let internals = <div>
            <p><span class="bolded-text">{parts[0] + ":"}</span>{parts[1]}</p>
            <p><span class="bolded-text">{parts[2] + ":"}</span>{parts[3]}</p>
            <p><span class="bolded-text">{parts[4] + ":"}</span>{parts[5]}</p>
        </div>

        str =
            <span style={myStyle}>
                {internals}


            </span>
    }
    else {
        str = <span style={myStyle}>
            {value}
        </span>;
    }

    return str;
};


export function GS1Renderer({ value }) {
    if (!value)
        return;

    value = value.replace(/\n/g, ":");

    let cellValue = value;
    let textToBold = ":";
    let parts = cellValue.split(textToBold);

    let str = "";

    if (parts && parts.length >= 7) {
        let internals = <div>
            <p><span class="bolded-text">{parts[0] + ":"}</span>{parts[1]}</p>
            <p><span class="bolded-text">{parts[2] + ":"}</span>{parts[3]}</p>
            <p><span class="bolded-text">{parts[4] + ":"}</span>{parts[5]}</p>
            <p><span class="bolded-text">{parts[6] + ":"}</span>{parts[7]}</p>
        </div>
        str =
            <span style={myStyle}>
                {internals}
            </span>
    }
    else {
        str = <span style={myStyle}>
            {value}
        </span>;
    }


    return str;
};

export function OM1Renderer({ value }) {
    if (!value)
        return;

    value = value.replace(/\n/g, ":");

    let cellValue = value;
    let textToBold = ":";
    let parts = cellValue.split(textToBold);

    let str = "";

    if (parts && parts.length >= 1) {
        let internals = <div>
            <p><span class="bolded-text">{parts[0] + ":"}</span>{parts[1]}</p>
            <p><span class="bolded-text">{parts[2] + ":"}</span>{parts[3]}</p>
        </div>
        str =
            <span style={myStyle}>
                {internals}
            </span>
    }
    else {
        str = <span style={myStyle}>
            {value}
        </span>;
    }


    return str;
};


export function IsValidRenderer({ value }) {
    let str = <p><span class="is-valid-text">{value ? "Yes" : "No"}</span></p>;
    
    return <span style={myStyle}>
            {str}
    </span>;
};

